import { ROUTE_EPS } from "@synapse/engine";

import type { Achievement } from "../achievement.types";

export const iKnowAShortcutAchievement: Achievement = {
  id: "iKnowAShortcut",
  name: "I Know a Shortcut",
  icon: "map-marker-path",
  description:
    "Won by a longer route that covered less distance than the gold path.",
  isProgressive: true,
  // Judges the route won by (the final playerPath): more hops than the gold
  // path, and less distance than it by more than ROUTE_EPS. Only possible when
  // a lower-distance, longer route exists.
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) return false;
    const { playerPath, optimalPath } = gameReport;
    if (!playerPath?.length || !optimalPath?.length) return false;
    return (
      playerPath.length > optimalPath.length &&
      gameReport.playerSemanticDistance <
        gameReport.optimalSemanticDistance - ROUTE_EPS
    );
  },
};
